import { formApi, formsApi } from 'app/services/api';

import { FeatureFlag } from 'constants/featureFlags';
import { catchAsyncActionError } from 'utils/action';

import { selectFeatureFlagByKey } from 'store/global/selectors';

export const exportPrismFormPdfAction = catchAsyncActionError(
  params => async (dispatch, getState) => {
    const isFormsConsolidationEnabled = selectFeatureFlagByKey(
      FeatureFlag.FormsConsolidationEnabled,
    )(getState());

    const previewApi = isFormsConsolidationEnabled ? formsApi : formApi;

    const { data } = await previewApi.previewPrismFormPdf(params);

    return data;
  },
);
